import React, { useState, useEffect } from "react";
import { ROUTE_LOGIN } from "../../authentication/routes";
import "./productOverview.css";
import ApiProductFeatures from "../apiProductFeatures/apiProductFeatures";
import ApiProductAdvantages from "../apiProductAdvantages/apiProductAdvantages";
import ApiProductApis from "../apiProductApis/apiProductApis";
import ApiProductRelatedApis from "../apiProductRelatedApis/apiProductRelatedApis";
import Breadcrumb from "../breadcrumb/breadcrumb";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import { getRouteUrl } from "../../routers";
import { ROUTE_PRODUCT_VIEW_SINGLE } from "../../routers/content/product";
import { productLink } from "../../utils/resolveProductFamily";
import HeaderImage from "../headerImage/headerImage";
import BracketButton from "../bracketButton/bracketButton";
import ComparisonTable from "../comparisonTable/comparisonTable";
import ChangeLog from "../changeLog/changeLog";
import "../changeLog/changeLog.css";
import Heading from "../heading/heading";
import v4 from "uuid";
import _ from "lodash";
import { parseChangeLog } from "../../constants/parse/product";

function ProductOverview(props) {
  const {
    disable_documentation,
    commercialProduct,
    breadcrumb,
    alias,
    deprecated,
    uuid,
    title,
    description,
    features,
    related,
    headerImage,
    overviewDisplayToggler,
    subscribeToggler,
    advantagesHeader,
    isLoggedIn,
    advantages,
    subscribed,
    comparisonTable,
    productCategories,
    changeLog,
    apis,
  } = props;

  const history = useHistory();
  // Removed Swagger link; no need to compute first API swagger URL

  const [activeAdvantage, setActiveAdvantage] = useState(
    advantages ? advantages[0] : null
  );
  const showAdvantage = (uuid) => {
    const activeAdvantage = advantages.find((a) => a.uuid === uuid);
    setActiveAdvantage(activeAdvantage);
  };
  const isPSD2 = productCategories
    .map((p) => p.name.toUpperCase())
    .includes("PSD2");

  useEffect(() => {
    if (advantages && advantages.length > 0 && advantages[0]) {
      setActiveAdvantage(advantages[0]);
    }
  }, [advantages]);

  return (
    <>
      <Breadcrumb
        {...breadcrumb}
        params={{
          product: {
            name: title,
            href: alias
              ? productLink(alias, deprecated)
              : getRouteUrl(ROUTE_PRODUCT_VIEW_SINGLE, { apiProductId: uuid }),
          },
        }}
      />

      <HeaderImage
        title={{
          main: title,
          sub: "API PRODUCT",
        }}
        image={headerImage}
        description={description}
        uuid={uuid}
        commercialProduct={commercialProduct}
        subscribed={subscribed}
      >
        {!disable_documentation ? (
          <>
            <BracketButton
              title="START USING THIS API"
              className="movingBrackets left"
              onClick={() => {
                if (isLoggedIn) {
                  subscribeToggler();
                } else {
                  // Same login route the "login to view" page uses; the user comes back here after signing in.
                  history.push(
                    getRouteUrl(ROUTE_LOGIN, null, {
                      returnTo:
                        window.location.pathname + window.location.search,
                    })
                  );
                }
              }}
              caretEnable
            />
            {/* Swagger view link removed as requested */}
          </>
        ) : null}
      </HeaderImage>
      {features && features.length > 0 && (
        <ApiProductFeatures
          features={features}
          uuid={uuid}
          disable_documentation={disable_documentation}
          productCategories={productCategories}
          isLoggedIn={isLoggedIn}
          subscribeToggler={subscribeToggler}
        />
      )}
      {/* ApiProductAdvantages doubles as the ChangeLog host (it has its own internal
          advantages/changelog toggle) - a product with changelog entries but no advantages
          must still render this section, or its changelog never shows on the Overview tab.
          Found via E2E testing 2026-09-20 - see devportal-manager-cms-feature memory. */}
      {((advantages && advantages.length > 0) ||
        (changeLog && changeLog.length > 0)) && (
        <ApiProductAdvantages
          isPSD2={isPSD2}
          advantagesHeader={advantagesHeader}
          advantages={advantages}
          activeAdvantage={activeAdvantage}
          showAdvantage={showAdvantage}
          uuid={uuid}
          overviewDisplayToggler={overviewDisplayToggler}
          subscribeToggler={subscribeToggler}
          isLoggedIn={isLoggedIn}
          disable_documentation={disable_documentation}
          apis={props.apis}
          changeLog={changeLog}
        />
      )}
      {!(advantages && advantages.length > 0) &&
        !(changeLog && changeLog.length > 0) &&
        !disable_documentation &&
        props.apis &&
        props.apis.length > 0 && <ApiProductApis apis={props.apis} />}
      {comparisonTable && comparisonTable.productNames.length > 0 && (
        <ComparisonTable comparisonTable={comparisonTable} uuid={uuid} />
      )}
      {/* Related APIs - moved to bottom */}
      {related && related.length > 0 && (
        <ApiProductRelatedApis related={related} />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.applicationUser?.isLoggedIn,
});

export default connect(mapStateToProps, null)(ProductOverview);
